import React from "react";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
} from "@mui/material";

function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  actionType,
  selectedOrganizationName,
  setSelectedOrganizationName,
  hasError,
  setHasError,
}) {
  // Determine the dialog content based on actionType
  let dialogTitle, dialogMessage, buttonLabel, buttonColor;

  switch (actionType) {
    case "enable":
      dialogTitle = "Enable Organization?";
      dialogMessage = "Are you sure you want to enable this organization?";
      buttonLabel = "Enable";
      buttonColor = "green";
      break;
    case "disable":
      dialogTitle = "Disable Organization?";
      dialogMessage = "Are you sure you want to disable this organization?";
      buttonLabel = "Disable";
      buttonColor = "red";
      break;
    case "delete":
      dialogTitle = "Delete Organization?";
      dialogMessage =
        "Are you sure you want to delete this organization? This action cannot be undone.";
      buttonLabel = "Delete";
      buttonColor = "red";
      break;
    case "create":
      dialogTitle = "Create Organization?";
      dialogMessage =
        "Are you sure you want to delete this organization? This action cannot be undone.";
      buttonLabel = "Create";
      buttonColor = "green";
      break;
    case "edit":
      dialogTitle = "Edit Organization?";
      dialogMessage =
        "Are you sure you want to delete this organization? This action cannot be undone.";
      buttonLabel = "Edit";
      buttonColor = "green";
      break;
    default:
      dialogTitle = "Confirm Action";
      dialogMessage = "Are you sure you want to proceed with this action?";
      buttonLabel = "Confirm";
      buttonColor = "blue";
      break;
  }

  return (
    <Dialog open={open} onClose={onClose} fullWidth>
      <DialogTitle>{dialogTitle}</DialogTitle>
      <DialogContent>
        {actionType === "delete" ? (
          <MDTypography>{dialogMessage}</MDTypography>
        ) : actionType === "create" ? (
          <TextField
            label="Organization Name"
            placeholder="Enter Organization Name"
            value={selectedOrganizationName}
            onChange={(e) => {
              setSelectedOrganizationName(e.target.value);
              setHasError(false);
            }}
            error={hasError} // Show red border only when there's an error
            helperText={hasError ? "This field is required." : ""} // Show helper text on error
            sx={{ width: 400, margin: "50px 50px 50px 0" }}
          />
        ) : (
          <TextField
            label="Organization Name"
            placeholder="Enter Organization Name"
            value={selectedOrganizationName}
            onChange={(e) => {
              setSelectedOrganizationName(e.target.value);
              setHasError(false);
            }}
            error={hasError} // Show red border only when there's an error
            helperText={hasError ? "This field is required." : ""} // Show helper text on error
            sx={{ width: 400, margin: "50px 50px 50px 0" }}
          />
        )}
      </DialogContent>
      <DialogActions>
        <MDButton onClick={onClose} color="secondary">
          Cancel
        </MDButton>
        <MDButton
          onClick={onConfirm}
          style={{
            backgroundColor: buttonColor,
            color: "#fff",
          }}
        >
          {buttonLabel}
        </MDButton>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmDialog;